export default __webpack_public_path__ + "static/media/Apotheosis of Pain.084c7544.jpg";